/* eslint-disable complexity */
/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import H2 from "../../shared/h2/component";

import BuyWithConfidenceCard from "../buy-with-confidence-card/component";
import financeFirstExpImage from "./image/financeFirstExpImage.svg";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import OverflowContainer from "../../shared/container-overflow";
import FasterLoanImg from "./image/faster-loan.png";
import BuyWithConfidenceBanner from "./image/bwc-banner.png";
import LazyImage from "../../shared/lazy-image";
import { PAGE_SOURCE } from "../../../constants/app-constants";
const financeFirstExperimentObj = {
    text: (
        <React.Fragment>
            Loan eligibility in <br /> <span>2 mins</span>
        </React.Fragment>
    ),
    hyperLink: "/financing/get-pre-approval",
    icon: financeFirstExpImage,
    showFinanceFirstExperimentCard: true,
    btnText: "Get Pre-approval >>"
};

const stUser = {
    text: (
        <p styleName={"styles.stBrandingStyle"}>
            <span>12x faster</span> <br />
            loan approval
        </p>
    ),
    icon: FasterLoanImg,
    showFinanceFirstExperimentCard: true,
    btnText: null
};

const BuyWithConfidenceRevamp = ({
    buyWithConfidence = [],
    config,
    source,
    preApproved,
    showHeader,
    quotesAvailable,
    stEligibleData = {},
    stEligible
}) => {
    const isStEligible = (stEligibleData || {}).isStEligible || stEligible || false;

    const isPreApproved = preApproved || quotesAvailable;
    const handleClick = (hyperLink) => {
        if (hyperLink) {
            window.open(hyperLink);
        }
    };

    // showFinanceFirstExperiment has scaled to varaint B
    const showFinanceFirstExperimentVariantCard = !isPreApproved;

    // eslint-disable-next-line no-nested-ternary
    buyWithConfidence = showFinanceFirstExperimentVariantCard
        ? [financeFirstExperimentObj, ...buyWithConfidence]
        : isStEligible
            ? [stUser, ...buyWithConfidence.slice(1)]
            : buyWithConfidence;

    const filteredBuyWithConfidence = buyWithConfidence.filter((item) => {
        const { id = "" } = item || {};
        return !(id === "finance_pre_approval" && showFinanceFirstExperimentVariantCard);
    });
    return (
        <React.Fragment>
            {showHeader && <H2 text="Buy with confidence" />}
            {source === PAGE_SOURCE.CDP.toUpperCase() && (
                <div styleName="styles.priceBenefitsWrapper">
                    <LazyImage src={BuyWithConfidenceBanner} styleName="styles.priceBenefitsImage" />
                    <div styleName="styles.priceBenefitsGradient" />
                    <p styleName="styles.priceBenefitsText">
                        CARS24 invests $1,200- $2,000 per car for unmatched quality, value, and performance
                    </p>
                </div>
            )}
            <div styleName={"styles.wrapper"}>
                <OverflowContainer>
                    {filteredBuyWithConfidence.map((item) => (
                        <BuyWithConfidenceCard
                            cardImage={getFastlyImage(config, item.image)}
                            cardTitle={item.text}
                            onClick={() => handleClick(item.hyperLink)}
                            hyperLink={item.hyperLink}
                            showFinanceFirstExperimentCard={item.showFinanceFirstExperimentCard}
                            btnText={item.btnText}
                            icon={item.icon}
                        />
                    ))}
                </OverflowContainer>
            </div>
        </React.Fragment>
    );
};

BuyWithConfidenceRevamp.propTypes = {
    buyWithConfidence: PropTypes.array,
    preApproved: PropTypes.bool,
    config: PropTypes.object,
    personalised: PropTypes.bool,
    quotesAvailable: PropTypes.bool,
    showHeader: PropTypes.bool,
    source: PropTypes.string,
    stEligibleData: PropTypes.object,
    stEligible: PropTypes.bool
};

export default BuyWithConfidenceRevamp;
